/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Payment_InfoInputs */

const en_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Payment Information`)
};

const ar_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث معلومات الدفع`)
};

const de_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsinformationen aktualisieren`)
};

const es_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiza la información de pago`)
};

const fr_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour les informations de paiement`)
};

const it_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna le informazioni di pagamento`)
};

const ja_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払い情報の更新`)
};

const ko_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 정보 업데이트`)
};

const pt_br_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar dados de pagamento`)
};

const ru_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить платежную информацию`)
};

const th_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตข้อมูลการชำระเงิน`)
};

const tr_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme Bilgilerini Güncelle`)
};

const zh_cn_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新付款信息`)
};

const zh_tw_btn_payment_info = /** @type {(inputs: Btn_Payment_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新付款資訊`)
};

/**
* | output |
* | --- |
* | "Update Payment Information" |
*
* @param {Btn_Payment_InfoInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_payment_info = /** @type {((inputs?: Btn_Payment_InfoInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Payment_InfoInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_payment_info(inputs)
	if (locale === "ar") return ar_btn_payment_info(inputs)
	if (locale === "de") return de_btn_payment_info(inputs)
	if (locale === "es") return es_btn_payment_info(inputs)
	if (locale === "fr") return fr_btn_payment_info(inputs)
	if (locale === "it") return it_btn_payment_info(inputs)
	if (locale === "ja") return ja_btn_payment_info(inputs)
	if (locale === "ko") return ko_btn_payment_info(inputs)
	if (locale === "pt_br") return pt_br_btn_payment_info(inputs)
	if (locale === "ru") return ru_btn_payment_info(inputs)
	if (locale === "th") return th_btn_payment_info(inputs)
	if (locale === "tr") return tr_btn_payment_info(inputs)
	if (locale === "zh_cn") return zh_cn_btn_payment_info(inputs)
	return zh_tw_btn_payment_info(inputs)
});